var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarBlank = function SvgCalendarBlank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24292D",
    d: "M11.865 2a.5.5 0 0 1 .5.5v.589h.615a1.5 1.5 0 0 1 1.5 1.5v7.106a1.5 1.5 0 0 1-1.5 1.5H4.5a1.5 1.5 0 0 1-1.5-1.5V4.59a1.5 1.5 0 0 1 1.5-1.5h.614l.001-.59a.5.5 0 0 1 .41-.491L5.615 2a.5.5 0 0 1 .5.5v.589h5.25v-.59a.5.5 0 0 1 .41-.491zm1.615 4.642H4v5.053a.5.5 0 0 0 .5.5h8.48a.5.5 0 0 0 .5-.5V6.642zM5.114 4.089H4.5a.5.5 0 0 0-.5.5v1.053h9.48V4.589a.5.5 0 0 0-.5-.5h-.616l.001.358a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.5-.5v-.358h-5.25v.358a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.5-.5v-.358z"
  })));
};
export default SvgCalendarBlank;